import {
  Box,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import {
  convertArrayToString,
  customTextColor,
  formatDate,
  formatTime,
} from "../../../utils/const";
import { useEffect, useState } from "react";
import profile_image from "../../../assets/images/ajit_image.jpeg";
import { IoIosAdd } from "react-icons/io";
import { IoIosArrowRoundBack } from "react-icons/io";
import { PiUserLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import RequirementsJobList from "../../../components/common/RequirementsJobList";
import {
  getOneSubmissionTracker,
  updateActionSubmissiontracker,
} from "../../../redux/internal-tracking/InternalSubmissionSlice";
import { useDispatch, useSelector } from "react-redux";
import { BsThreeDotsVertical } from "react-icons/bs";

const InternalTrackerView = () => {
  const [viewData, setViewData] = useState();
  const [open, setOpen] = useState(false);
  const [btn1, setBtn1] = useState("");
  const [openAction, setOpenAction] = useState(false);
  const [actionName, setActionName] = useState("");
  const [isChangeAction, setIsChangeAction] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { row } = location.state || {};
  const { index } = location.state || {};
  const viewdata = useSelector((state) => state.trackersubmission.trackerData);
  const trackerStatus = useSelector((state) => state.trackersubmission.status);
  const skillData = useSelector((state) => state.skill.data);
  const locations = useSelector((state) => state.location);
  const [isProfileVisible, setIsProfileVisible] = useState(false);
  const internalSubStatus = useSelector(
    (state) => state.trackersubmission.status
  );
  const oneSubmisionStatus = useSelector(
    (state) => state.trackersubmission.oneSubmisionStatus
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const submissionTrackerStatus = useSelector(
    (state) => state.trackersubmission.status
  );

  const [data, setData] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalSubmissionDetails"))
  );

  useEffect(() => {
    if (data) {
      let id = data?.row?.requirement_tracker_id;

      dispatch(getOneSubmissionTracker(id));
    }
  }, [data]);

  useEffect(() => {
    if (location.state) {
      localStorage.setItem(
        "internalSubmissionDetails",
        JSON.stringify(location.state)
      );
      setData(location.state);
    }
  }, [location.state]);


  useEffect(() => {
    setViewData(viewdata?.data);
  }, [viewdata]);

  useEffect(() => {
    if (trackerStatus === "add_candidate_to_submission") {
      let id = data?.row?.requirement_tracker_id;
      dispatch(getOneSubmissionTracker(id));
    }
  }, [trackerStatus, data]);

  const getSkillNames = (skills) => {
    return skills
      ?.map(
        (id) => skillData?.locations?.find((skill) => skill.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };
  const handleThreeDotsClick = () => {
    setIsProfileVisible(!isProfileVisible);
  };
  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenAction = () => {
    setOpenAction(true);
  };

  const handleCloseAction = () => {
    setOpenAction(false);
  };

  const handleOnChangeAction = (name) => {
    setActionName(name);
  };

  const handleOnClickChangeAction = () => {
    let values = {
      job_status: btn1,
      job_title: viewData?.job_title,
    };
    let id = viewData?.requirement_tracker_id;
    dispatch(updateActionSubmissiontracker({ values, id }));
    setIsChangeAction(true);
  };

  useEffect(() => {
    if (
      submissionTrackerStatus === "update_requirement_tracker_action" &&
      isChangeAction
    ) {
      let id = data?.row?.requirement_tracker_id;
      dispatch(getOneSubmissionTracker(id));
      handleClose();
      handleCloseAction();
      setIsChangeAction(false);
    }
  }, [submissionTrackerStatus]);

  useEffect(() => {
    if (viewData) {
      setBtn1(viewData?.job_status);
    }
  }, [viewData, submissionTrackerStatus]);

  const whichStatus = (value) => {
    let status;
    if (value === "Active") {
      status = "Open";
    } else if (value === "On Hold") {
      status = "Hold";
    } else if (value === "Closed") {
      status = "Close";
    }
    return status;
  };

  const handleSelect = (text) => {
    setBtn1(text);
    handleOpen();
  };

  return (
    // <RootComponents>
    <>
      {oneSubmisionStatus === "loading" ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 230,
          }}
        >
          <CircularProgress size={30} color="info" />
        </Box>
      ) : (
        <Box className={styles.add_structure}>
          <Grid
            container
            className={styles.verification_phase}
            sx={{ backgroundColor: "#fff" }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={2.9}
              lg={2.9}
              sx={{ color: customTextColor, border: "none !important" }}
            >
              <Typography sx={{ marginLeft: "0 !important" }}>
                Track on:{" "}
                <b>
                  {viewData?.created_at !== undefined &&
                    formatDate(viewData?.created_at)}{" "}
                  {viewData?.created_at !== undefined &&
                    formatTime(viewData?.created_at)}
                </b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={2.9}
              lg={2.9}
              sx={{ color: customTextColor }}
            >
              <Typography>
                Internal Submission: <b> {index ? index + 1 : 0}</b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={2.9}
              lg={2.9}
              sx={{ color: customTextColor }}
            >
              <Typography>
                Client Submission: <b> {viewData?.job_status}</b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={2.9}
              lg={2.9}
              sx={{ color: customTextColor }}
            >
              <Typography>
                Interview: <b> 01 </b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={0.4}
              lg={0.4}
              sx={{ color: customTextColor, border: "none !important" }}
            >
              <BsThreeDotsVertical
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  marginLeft: "15px",
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            className={styles.candidates_name}
            sx={{ marginBottom: "14px" }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                className={styles.requirement_details_view}
                sx={{ color: customTextColor }}
              >
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <span>
                    <Box>
                      <PiUserLight
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Received from: <b>{viewData?.bdm_name}</b>
                      </Typography>
                    </Box>

                    <Box sx={{ marginBottom: "0 !important" }}>
                      <PiMailboxLight
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Work Email ID : <b>{viewData?.bdm_email}</b>
                      </Typography>
                    </Box>
                  </span>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <span>
                    <Box>
                      <PiUserLight
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Company Name: <b>{viewData?.company_name}</b>
                      </Typography>
                    </Box>

                    <Box sx={{ marginBottom: "0 !important" }}>
                      <CiMobile3
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Phone No: <b>{viewData?.bdm_mobile_no}</b>
                      </Typography>
                    </Box>
                  </span>
                </Grid>
              </Grid>
            </Grid>
           
          </Grid>

          <Box className={styles.profile_submit}>
            <Box>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  <Typography sx={{ marginTop: "10px !important" }}>
                    <b>
                      {viewData?.requirement_tracker_id}, {viewData?.job_title}{" "}
                      with {viewData?.experience} Years’ Experience at
                      {getLocationById(viewData?.location)},{" "}
                    </b>
                  </Typography>
                  <Typography>
                    <b>
                      {viewData?.duration} {viewData?.duration ? "Month" : ""}{" "}
                      {convertArrayToString(viewData?.requirement_type)}
                      {/* {viewData?.job_type} */}
                    </b>
                  </Typography>
                  <Typography>
                    <b>
                      From ${viewData?.rate}{" "}
                      {viewData?.requirement_type?.includes("full_Time")
                        ? "Yearly"
                        : "Hourly"}
                    </b>
                  </Typography>
                  <Typography>
                    <b> {viewData?.mode_of_interview} Interview</b>
                  </Typography>
                </span>

                <span
                  className={styles.phase2}
                  style={{ marginTop: "10px", alignSelf: "start" }}
                >
                  <Typography>
                    {data?.row?.created_at !== undefined &&
                      formatDate(data?.row?.created_at)}{" "}
                    {data?.row?.created_at !== undefined &&
                      formatTime(data?.row?.created_at)}
                  </Typography>
                </span>
              </span>
            </Box>
          </Box>

          <Box className={styles.candidate_text}>
            {" "}
            <span>
              <Typography>
                <b>Job Description</b>
              </Typography>
              <Typography>
                {viewData?.job_description}
                {/* <div>
                Extensive experience with AWS offerings such as EC2, S3, RDS,
                IAM, and other related services. <br/> Agile development methodologies
                and DevOps practices to enable frequent and incremental
                development, testing,  <br/> and deployments.
              </div> */}
              </Typography>
              <Typography>
                <b>Mandatory Skills</b>
              </Typography>
              <Typography>{viewData?.skills}</Typography>
            </span>
          </Box>

          <Box className={styles.mass_new_structure}>
            <Box className={styles.new_header_text}>
              <Typography>Internal Submissions Tracker</Typography>
              <button
                onClick={() => {
                  navigate("/internal-tracker-employee", {
                    state: {
                      row: row,
                      type: "view",
                      candidates: viewData?.candidates,
                    },
                  });
                }}
              >
                Add Candidate
                <IoIosAdd style={{ fontSize: "25px", marginLeft: "5px" }} />
              </button>
            </Box>

            {internalSubStatus === "loading" ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 230,
                }}
              >
                <CircularProgress size={30} color="info" />
              </Box>
            ) : (
              <Box className={styles.requiter_profile_section}>
                {viewData?.candidates?.map((res) => {
                  return (
                    <RequirementsJobList
                      image={profile_image}
                      name={res?.full_name}
                      skill={viewData?.job_title}
                      phoneno={res?.mobile_no}
                      email={res?.email}
                      btn1="Update"
                      btn2="View Details"
                      res={res}
                      row={row}
                      type="view"
                      viewData={viewData}
                    />
                  );
                })}
              </Box>
            )}
          </Box>
          <Box className={styles.requiter_profile_section}></Box>
          {internalSubStatus !== "loading" && (
            <Box className={styles.add_candidate_btns}>
              <Box className={styles.add_back_btns}>
                <button
                  onClick={() => navigate("/submision-tracker")}
                  style={{
                    border: "1.5px solid #4287f5",
                    marginRight: "10px",
                    padding: "4.5px 10px ",
                  }}
                >
                  <IoIosArrowRoundBack
                    style={{ fontSize: "25px", color: "#4287f5" }}
                  />
                </button>
              </Box>

              <div className="btn-group">
                <button
                  type="button"
                  className="dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{
                    color: "black",
                    width: "7rem",
                    border: "1.5px solid #4287f5",
                    padding: "6px 10px",
                  }}
                >
                  {whichStatus(btn1)}
                </button>
                <div className="dropdown-menu">
                  <a
                    className="dropdown-item"
                    style={{ backgroundColor: "#fff" }}
                    onClick={() => handleSelect("Active")}
                  >
                    Open
                  </a>
                  <a
                    className="dropdown-item"
                    style={{ backgroundColor: "#fff" }}
                    onClick={() => handleSelect("On Hold")}
                  >
                    Hold
                  </a>
                  <a
                    className="dropdown-item"
                    style={{ backgroundColor: "#fff" }}
                    onClick={() => handleSelect("Closed")}
                  >
                    Close
                  </a>
                </div>
              </div>
            </Box>
          )}
        </Box>
      )}

      <Dialog
        fullScreen={fullScreen}
        open={openAction}
        // onClose={handleCloseAction}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
            <Box>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  value="Active"
                  checked={actionName === "Active"}
                  onChange={() => handleOnChangeAction("Active")}
                />
                <label class="form-check-label" htmlFor="exampleRadios1">
                  Open
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios2"
                  value="On Hold"
                  checked={actionName === "On Hold"}
                  onChange={() => handleOnChangeAction("On Hold")}
                />
                <label class="form-check-label" htmlFor="exampleRadios2">
                  Hold
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios3"
                  value="Closed"
                  checked={actionName === "Closed"}
                  onChange={() => handleOnChangeAction("Closed")}
                />
                <label class="form-check-label" htmlFor="exampleRadios3">
                  Close
                </label>
              </div>
            </Box>
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                // onClick={handleOnClickStatusChange}
                onClick={handleOpen}
              >
                Change
              </button>
              <button
                sx={{ backgroundColor: "#97B6F1" }}
                onClick={handleCloseAction}
              >
                Cancel
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        maxWidth="sm"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center" }}
          >
            <b>Job Action Change</b>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            Are you sure you want to change action to {whichStatus(btn1)}
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                // onClick={handleOnClickStatusChange}
                onClick={handleOnClickChangeAction}
              >
                Yes
              </button>
              <button sx={{ backgroundColor: "#97B6F1" }} onClick={handleClose}>
                No
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
    // </RootComponents>
  );
};

export default InternalTrackerView;
